// components/BookingDetails/AddPetsServicesButton.jsx
import React from "react";
import { FiPlusCircle, FiArrowRightCircle } from "react-icons/fi";

const AddPetsServicesButton = ({ onClick, mode = "details", disabled = false }) => {
  const buttonText = mode === "update" ? "Edit Pets & Services" : "Add Pets & Services";
  
  return (
    <div className="my-3">
      <button
        onClick={onClick}
        disabled={disabled}
        className={`w-full flex items-center lg-w-2/5 justify-between p-4 border-2 border-dashed rounded-xl transition-all duration-200 group ${
          disabled 
            ? "border-gray-200 bg-gray-50 cursor-not-allowed" 
            : "border-blue-300 hover:border-blue-500 hover:bg-blue-50"
        }`}
      >
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 ${
            disabled 
              ? "bg-gray-100" 
              : "bg-gradient-to-r from-blue-100 to-indigo-100 group-hover:from-blue-200 group-hover:to-indigo-200"
          }`}>
            <FiPlusCircle className={`w-5 h-5 ${disabled ? "text-gray-400" : "text-blue-600"}`} />
          </div>
          <span className={`font-medium transition-colors duration-200 ${
            disabled ? "text-gray-400" : "text-gray-700 group-hover:text-blue-700"
          }`}>
            {buttonText}
          </span>
        </div>
        <FiArrowRightCircle className={`w-5 h-5 transition-colors duration-200 ${
          disabled ? "text-gray-300" : "text-gray-400 group-hover:text-blue-600"
        }`} />
      </button>
    </div>
  );
};

export default AddPetsServicesButton;